import { render } from "./AppLogo.vue?vue&type=template&id=624e4736&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"

import "./AppLogo.vue?vue&type=style&index=0&id=624e4736&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-624e4736"

export default script